const _ = require("lodash");
const {setIn, extendIn} = require("./ImmHelpers");

// Functions that formerly lived in OpsCart (though most are reexported). They
// were moved to shared so that StoreBundleUtil can take advantage of them.

const areItemsEqual = function(item1, item2, ignoreBundleID) {
	const item1Opts = ignoreBundleID
		? _.omit(item1.options, "bundleID")
		: item1.options;
	const item2Opts = ignoreBundleID
		? _.omit(item2.options, "bundleID")
		: item2.options;
	return item1.sku === item2.sku && _.isEqual(item1Opts, item2Opts);
};

const findItemIndex = function(cartItems, item) {
	return _.findIndex(cartItems, i => areItemsEqual(i, item));
};

// This immutably modifies cart.items by adjusting the amount of one item in
// the cart or adding a new item to the cart.
// - cartItems: the cloned cart items array to adjust,
// - sku: the sku of the item whose amount is changing
// - delta: the integer change in quantity of that item
// - opts: any other options for the relevant item
//   (like {size: "large", color: "blue"}), not applicable to books
const adjustItem = function(cartItems, sku, delta, opts = {}) {
	if (delta === 0) {
		return cartItems;
	}
	const currentIndex = findItemIndex(cartItems, {sku, options: opts});
	if (currentIndex >= 0) {
		cartItems = _.clone(cartItems);
		//Item with that sku already in the cartItems.
		const newQty = cartItems[currentIndex].quantity + delta;
		if (newQty > 0) {
			cartItems[currentIndex] = _.extend({}, cartItems[currentIndex], {
				quantity: newQty,
			});
		} else {
			cartItems.splice(currentIndex, 1);
		}
	} else if (delta > 0) {
		cartItems = _.clone(cartItems);
		//Item must be added to the cartItems since one with the sku + options is not present.
		cartItems.push({sku, quantity: delta, options: opts});
	}
	return cartItems;
};

const removeItem = function(cartItems, itemToRemove) {
	const removalIndex = findItemIndex(cartItems, itemToRemove);
	if (removalIndex >= 0) {
		const newItems = _.clone(cartItems);
		newItems.splice(removalIndex, 1);
		return newItems;
	}
	return cartItems;
};

const updateItemQuantity = function(cartItems, itemToUpdate, newQuantity) {
	if (newQuantity <= 0) {
		return removeItem(cartItems, itemToUpdate);
	}
	const updateIndex = findItemIndex(cartItems, itemToUpdate);
	if (updateIndex >= 0) {
		cartItems = setIn(cartItems, [updateIndex, "quantity"], newQuantity);
	}
	return cartItems;
};

const updateItemOptions = function(cartItems, itemToUpdate, newOptions) {
	const updateIndex = findItemIndex(cartItems, itemToUpdate);
	if (!_.isEqual(itemToUpdate.options, newOptions) && updateIndex >= 0) {
		cartItems = extendIn(cartItems, [updateIndex, "options"], newOptions);
	}
	return cartItems;
};

const updateItemSku = function(cartItems, itemToUpdate, newSku) {
	const updateIndex = findItemIndex(cartItems, itemToUpdate);
	if (itemToUpdate.sku !== newSku && updateIndex >= 0) {
		cartItems = setIn(cartItems, [updateIndex, "sku"], newSku);
	}
	return cartItems;
};

module.exports = {
	areItemsEqual,
	findItemIndex,
	adjustItem,
	removeItem,
	updateItemQuantity,
	updateItemOptions,
	updateItemSku,
};
